import { Col, Row } from 'react-grid-system';
import { useUserLanguage } from '@/customHooks';
import styled from 'styled-components';
import textsData from '@/textData/CreateContractsTexts.json'
import {
  CreateContractConfirmationDialog,
  SelectContractLateFees,
  SelectContractLeaseTerm,
  SelectContractPropertyMenu,
  SelectContractRentCharges,
  SelectContractSecurityDeposit,
  SelectContractTenantMenu,
} from '../organism';

type CreateContractTemplateProps = {
  currentTemplate: number
}

const TextContainer = styled(Col)`
  text-align: center;
  margin-bottom: 3rem;
`
export const CreateContractTemplate = ({ currentTemplate }: CreateContractTemplateProps) => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  return (
    <>
      <Row>
        <TextContainer>
          <h1>{texts.templateText[currentTemplate].title}</h1>
          <p>{texts.templateText[currentTemplate].description}</p>
        </TextContainer>
      </Row>
      {
        (() => {
          switch(currentTemplate) {
            case 0:
              return <SelectContractPropertyMenu />
            
            case 1:
              return <SelectContractLeaseTerm />

            case 2:
              return <SelectContractTenantMenu />

            case 3:
              return <SelectContractSecurityDeposit />

            case 4:
              return <SelectContractRentCharges />
              
            case 5:
              return <SelectContractLateFees />

            case 6:
              return <CreateContractConfirmationDialog />

            default:
              throw new Error('Invalid Current template [CreatePropertyTemplate]')
          }
        })()
      }
    </>
  )
}
